const createRefs = component => [...component.querySelectorAll('[data-ref]')].reduce(extract, {})

const extract = (refs, $ref) => {
    const { ref } = $ref.dataset

    // Check if ref is of type array
    const refArray = ref.match(/(\w+)\[(.+)\]/)

    if (refArray !== null) {
        return getRefArray(refs, $ref, refArray)
    } else {
        return { ...refs, [$ref.dataset.ref]: $ref }
    }
}

const getRefArray = (refs, $ref, [, name, index]) => {
    if (refs[name] === undefined) {
        refs[name] = []
    }
    refs[name][index] = $ref
    return refs
}

export default createRefs
